<template>
<div class="chapter">
<div class="inner_page">
<p class="h1a"><a id="page_ix"></a><a id="halftitle"></a><strong><em>After Fukushima:<br/>
  The Equivalence of Catastrophes</em></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle2.vue?4d49e7b7